import './average.scss';

export default () => {
	let a = 0;

	window.addEventListener( 'scroll', function () {
		const cardAverage = document.querySelector( '.card-average' );

		if ( !cardAverage ) return;

		const oTop = cardAverage.getBoundingClientRect().top + window.scrollY - window.innerHeight;

		if ( a === 0 && window.scrollY > oTop ) {
			const counters = document.querySelectorAll( '.counter' );

			counters.forEach( function ( counter ) {
				const countTo = parseInt( counter.getAttribute( 'data-number' ), 10 );
				let countNum = parseInt( counter.textContent.replace( /,/g, '' ), 10 ) || 0;

				const duration = 4000;
				const startTime = performance.now();

				function animate ( currentTime ) {
					const elapsed = currentTime - startTime;
					const progress = Math.min( elapsed / duration, 1 );
					const ease = 0.5 - Math.cos( progress * Math.PI ) / 2; // 'swing' easing

					const currentCount = Math.ceil( countNum + ( countTo - countNum ) * ease );

					counter.textContent = currentCount.toLocaleString( 'en' );

					if ( progress < 1 ) {
						requestAnimationFrame( animate );
					} else {
						counter.textContent = countTo.toLocaleString( 'en' );
					}
				}

				requestAnimationFrame( animate );
			} );

			a = 1;
		}
	} );
};
